import { TOKEN, USER } from '../modules/auth/model';
import { SESSION_LOGIN_REDIRECT } from '../constants';
import parseQueryString from './parseQueryString';
import harvestIdentifiers from './harvestIdentifiers';
import encodeQueryString from './encodeQueryString';
import fetch from 'node-fetch';
import clearCookies from './clearCookies';
import { StorageModel } from '../modules/storage/model';
import { ClientController } from '../modules/client/controller';
import { BASKET_IDENTITY } from '../modules/basket/model';

export default async function completeSignin(clientController: ClientController) {
  const redirect = (path = '/') => setTimeout(() => (window.location.href = path), 3000);

  const request = (url: string, headers: { [key: string]: string } = {}) =>
    fetch(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers,
      },
      mode: 'cors',
    });

  const storage = StorageModel;

  const existingUser = storage.getItem(USER);

  if (existingUser) return redirect();

  const queryString = document.location.search.slice(1);

  if (!queryString) return redirect();

  const { code } = parseQueryString(queryString);

  if (!code) return redirect();

  const identifiers = harvestIdentifiers();
  const claimTokenUrl = `${window.location.protocol}//${
    process.env.API_URL
  }/user/youtube/create?code=${code}&${encodeQueryString(identifiers)}`;

  const claimResponse = await request(claimTokenUrl);
  const claim = await claimResponse.json();

  if (!claim || !claim.token) {
    clientController.page.signin.toggleLoading();
    clientController.page.signin.setHasError();
    return;
  }

  const cookieKeys = Object.keys(identifiers).filter((key) => key !== BASKET_IDENTITY);

  clearCookies(cookieKeys);

  storage.setItem(TOKEN, claim.token);

  const sessionUrl = `${window.location.protocol}//${process.env.API_URL}/user/session`;
  const sessionResponse = await request(sessionUrl, { Authorization: `Bearer ${storage.getItem(TOKEN)}` });
  const session = await sessionResponse.json();

  if (!session || !session.data) return redirect();

  storage.setItem(USER, session.data);

  /**
   * If we're in the same browser tab as the main
   * app instance, then we aught to redirect back
   * as best we can, rather than try to close the window.
   *
   * This relies on setting the redirect when we are launched
   * from the main app instance window, if it is set in the current
   * session then we can redirect
   *
   * Best effort for skipping the JS loading dialog on page load
   * is redirect back to the home page
   */
  const sessionLoginRedirect = window.sessionStorage.getItem(SESSION_LOGIN_REDIRECT);

  if (sessionLoginRedirect) return redirect(decodeURIComponent(sessionLoginRedirect));

  return redirect();
}
